module.exports = __webpack_public_path__ + "img/apple-profile.fd379455.jpg";